import { fontSize } from "config/styles/fonts";

const styles = {
  subtitle: {
    fontSize: fontSize.s,
    mt: "10px",
  },
  formWrap: {
    mt: "20px",
  },
  inputsWrap: {
    display: "flex",
    gap: "10px",
  },
  inputWrap: {
    width: "100%",
    "& input": {
      height: "50px !important",
    },
  },
  textWrap: {
    "&.MuiGrid-root.MuiGrid-item": {
      pt: "8px",
    },
    "& .MuiTypography-root": {
      textAlign: "center",
      color: "text.secondary",
    },
  },
  codeInput: {
    flexBasis: "30%",
    "& .MuiInputBase-root": {
      height: "46px",
    },
  },
  codeBtn: {
    flexBasis: "70%",
    borderRadius: "50px",
    height: "46px",
    "&.MuiButtonBase-root": {
      letterSpacing: 0,
    },
  },
  button: {
    mt: "20px",
    height: "46px",
    borderRadius: "50px",
  },
};

export default styles;
